import { useEffect, useState } from 'react';
import { CompanyModalController } from '../model/CompanyModalController';

export const useModalState = (): boolean => {
  const [isOpen, setIsOpen] = useState(false);
  
  useEffect(() => {
    const controller = CompanyModalController.getInstance();
    return controller.subscribe(setIsOpen);
  }, []);

  return isOpen;
}; 